import { matchPath } from 'react-router-dom';
import AppRoutesEnum from 'common/routes/AppRoutes.enum';

export const isInExplorePage = (
  pathname: string,
  explorePath: AppRoutesEnum | string = AppRoutesEnum.EXPLORE,
): boolean => {
  return !!matchPath({ path: explorePath, end: false }, pathname);
};
